import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-block-title',
  standalone: true,
  imports: [
    CommonModule,
  ],
  template: `
    <span class="tw-bg-grey-100 tw-text-base tw-font-medium fx-center py-2 px-3 radius-4">
      {{ title }}
    </span>`,
  styleUrls: ['./block-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockTitleComponent {
  @Input() title = '';
}
